export default class BaseCharacter extends Phaser.GameObjects.Image {
  /**
   *  A simple prefab (extended game object class), displaying a spinning
   *  Phaser 3 logo.
   *
   *  @extends Phaser
   *
   *
   */

  constructor(scene, id, character, skin, animations, sfx) {
    super(scene, 0, 0, 'blank');
    // this.load.spine(character, json, atlas);
    this.spineRef = character;
    this.name = skin;
    this.animations = animations;
    this.idleAnims = animations.idles;
    this.shuffle(this.idleAnims);
    this.sfx = sfx;
    this.defaultMix = 0.05;
    this.emitter = new Phaser.Events.EventEmitter();
    scene.add.existing(this);
    this.ID = id;
    this.minIdleTime = 1500;
    this.maxIdleTime = 2500;
    this.idleCounter = this.randomRange(0, this.maxIdleTime);
    this.idleTime = Phaser.Math.Between(this.minIdleTime, this.maxIdleTime);
    // console.log('creating character --> ' + skin + ' from ' + character);
    this.spineChar = scene.add.spine(0, 0, character, this.lastPlayedAnim, true);
    // this.spineChar.on('spine.complete', this.handleAnimComplete, this);
    this.clickArea = scene.add.image(0, 0, 'blank');
    this.clickArea.setOrigin(0.5, 1);
    this.setSkin(skin);
    this.lastPlayedAnim = animations.default;
    this.transform = scene.add.container(0, 0);
    let container = scene.add.container(0, 0, [this.spineChar, this.clickArea]);
    // this.setOrigin(0.5, 1);
    this.transform.add(container);
    this.frozen = false;
    this.canIdle = true;
    this.idleActive = true;
  }

  kill() {
    this.clickArea.off('pointerdown');
  }

  wrap(value) {
    return value % 360;
  }

  setTransform(posX, posY, scaleX, scaleY, dir) {
    var x = posX;
    var y = posY;

    this.transform.setPosition(x, y);

    // this.transform.setRandomPosition();
    this.direction = dir;
    this.spineChar.setScale(scaleX * this.direction, scaleY);
    this.texBounds = this.spineChar.getBounds();
    this.charWidth = this.texBounds.size.x * this.spineChar.scaleX;
    this.charHeight = this.texBounds.size.y * this.spineChar.scaleY;
    this.clickArea.setDisplaySize(this.charWidth, this.charHeight);
  }

  updateCharacter(time, delta, scene) {
    if (this.idleActive === true) {
      this.updateIdle(scene, delta);
    }
  }

  shuffle(arr) {
    arr.sort(() => Math.random - 0.5);
  }

  updateIdle(scene, delta) {
    if (this.idleCounter >= this.idleTime) {
      // do idle anim
      this.idleCounter = 0;
      this.idleTime = Phaser.Math.Between(this.minIdleTime, this.maxIdleTime);
      this.setTimescale(0.9, 1.1);
      this.playAnimVariant(scene, this.idleAnims);
    } else {
      this.idleCounter += delta;
    }
  }

  setSortOrder(depth) {
    this.spinChar.setDepth(depth);
  }

  randomRange(min, max, round = false) {
    if (round) {
      return Phaser.Math.Between(min, max);
    } else {
      return Phaser.Math.Between(min * 100, max * 100) / 100;
    }
  }

  setSkin(skinName) {
    this.spineChar.setSkin(null);
    this.spineChar.setSkinByName(skinName);
    this.attachments = this.spineChar.skeleton.skin.attachments;
  }

  playAnim(scene, anim, mix, loop = false, returnToPrevious = true) {
    if (mix > 0) {
      this.spineChar.setMix(this.animations.default, anim, mix);
      this.spineChar.setAnimation(0, anim, loop, 0);
      let delay = this.spineChar.state.getCurrent(0).getAnimationLength() - mix;
      this.spineChar.setMix(anim, this.animations.default, mix);
      this.spineChar.addAnimation(0, this.animations.default, true, delay);
    }

    this.playing = true;
    this.returnToPrevious = returnToPrevious;
    this.currentAnimation = anim;
  }

  reset() {
    this.spineChar.clearTracks();
    this.spineChar.skeleton.setToSetupPose();
    this.spineChar.setAnimation(0, this.animations.default, true, 0);
  }

  playAnimVariant(scene, animations) {
    let idx = Phaser.Math.Between(0, animations.length - 1);
    let anim = animations[idx];
    /*     if (animations[idx].sfx !== undefined) {
          this.playAnim(
            scene,
            animations[idx].name,
            this.defaultMix,
            false,
            true // this.randomRange(0, this.animations.idles.length, true)
          );
          this.playAnimSFX(scene, animations[idx].sfx);
        } else {
          this.playAnim(
            scene,
            animations[idx],
            this.defaultMix,
            false,
            true // this.randomRange(0, this.animations.idles.length, true)
          );
        } */
    this.playAnim(
      scene,
      animations[idx],
      this.defaultMix,
      false,
      true // this.randomRange(0, this.animations.idles.length, true)
    );
    if (this.sfx.hasOwnProperty(anim)) {
      scene.sound.play(this.sfx[anim]);
    }
  }

  playAnimSFX(scene, sfx) {
    let idx = Phaser.Math.Between(0, sfx.length - 1);
    scene.sound.play(sfx[idx], { volume: 0.5 });
  }

  playHappy(scene) {
    this.idleCounter = 0;
    this.playAnimVariant(scene, this.animations.happy);
  }

  playCelebrate(scene, delay) {
    this.idleCounter = 0;
    if (delay !== undefined) {
      scene.time.delayedCall(delay, () => this.playAnimVariant(scene, this.animations.celebrate), this);
    } else {
      this.playAnimVariant(scene, this.animations.celebrate);
    }

  }

  playSad(scene) {
    this.idleCounter = 0;
    this.playAnimVariant(scene, this.animations.sad);
  }

  setTimescale(min, max) {
    let low = min * 100;
    let high = max * 100;
    let tScale = Phaser.Math.Between(low, high) / 100;
    this.spineChar.state.timeScale = tScale;
  }

  togglePause(paused) {
    this.idleActive = paused ? false : this.canIdle;
    this.spineChar.state.timeScale = paused ? 0 : 1;
  }

  handleCharacterClicked() {
    this.emitter.emit('characterClicked');
  }

  destroy() {
    this.transform.removeAll();
    this.transform = null;
    this.spineChar.destroy();
    this.spineChar = null;
    this.emitter = null;
    this.animations = null;
    super.destroy();
  }
}
